/** EPOS javascript SDK adapted for Telavox use
 * Original SDK available here: https://dseasdk.com/common/js/dseasdk.v1.js
 * Test site available here: https://dseasdk.com/demo/CCL.html
 */

/* eslint-disable */

import { EventEmitter } from 'events';

//EPOS USB vendor ID dummy
const EPOSVID = 0x1395;
const ABLID = 'Sennheiser_UI_20_BL_USB';

//general string functions
function dec2hexStringSimple(dec) {
    return (dec + 0x10000).toString(16).substr(-2).toUpperCase();
}
function dec2hexString(dec) {
    return '0x' + dec2hexStringSimple(dec);
}
//Device helper functions
function getDeviceID(dev) {
    var name = getDeviceName(dev).replaceAll(' ', '_');
    return name;
}
function getDeviceName(dev) {
    var name = dev.productName;
    name = name.replace('Sennheiser Sennheiser ', 'Sennheiser ');
    name = name.replaceAll('EPOS ', '');
    name = name.replace('Secom Sennheiser ', 'Sennheiser ');
    name = name.replace('SeCom Sennheiser ', 'Sennheiser ');
    return name;
}

const _version_str = '0.7';

//Libraries
class dseasdk extends EventEmitter {
    constructor(
        brand = '',
        name = '',
        version = '',
        forceHID = 0,
        logFunction,
    ) {
        super();
        this._webhidsdk = null;

        let this_ = this;
        this_.brand = brand;
        this_.name = name;
        this_.version = version;
        this_.forceHID = forceHID;

        if (logFunction) {
            this.mylog = {
                message: logFunction,
                error: (log) => logFunction('Error: ' + log),
            };
        } else {
            this.mylog = new log('LightGreen', 'PaleGreen');
            this.mylog.message('dseacallcontrollibrary initialized');
        }

        this.ws = undefined;
        this.wsWorking = false;
        this.wsConnected = false;
        this.wsLoggedIn = false;
        this.muteStatus = false;

        const socketopen = () => {
            this.mylog.message('Socket Opened');
            this.wsWorking = true;
        };
        const socketclose = () => {
            this.mylog.message('Socket Closed');
            this.wsWorking = false;
            if (navigator.hid && this_.forceHID >= 0) {
                this._webhidsdk = new webhid(
                    this_.brand,
                    this_.name,
                    this_.version,
                );
                this._postEvent('LoginStatusChanged', 'EstablishConnection');
            }
        };
        const socketmessage = (evt) => {
            if (!this.wsWorking) return;
            let jsonData = JSON.parse(evt.data);

            if (jsonData.EventType === 'Acknowledgement')
                this._acknowledgement(jsonData);
            else if (jsonData.EventType === 'Notification')
                this._notification(jsonData);
            else
                this.mylog.error(
                    'Unhandled Acknowledgement received ' + evt.data,
                );
        };

        if (forceHID > 0) {
            this.mylog.message('Forcing webHID');
            if (navigator.hid) {
                this._webhidsdk = new webhid(
                    this_.brand,
                    this_.name,
                    this_.version,
                    true,
                );
                this._postEvent('LoginStatusChanged', 'EstablishConnection');
            }
        } else {
            this.ws = new WebSocket('wss://127.0.0.1:41088');
            this.ws.onopen = socketopen;
            this.ws.onmessage = socketmessage;
            this.ws.onclose = socketclose;
        }
    }

    _postEvent = (name, param) => {
        setTimeout(() => {
            this.emit(name, param);
        }, 0);
    };

    _acknowledgement = function (jsonData) {
        const evnt = jsonData.Event;
        const callid = jsonData.CallID;

        if (parseInt(jsonData.ReturnCode) !== 0) {
            this.mylog.error(
                'ErrorCode ' + evnt + ' (' + jsonData.ReturnCode + ')',
            );
            return;
        }

        if (evnt === 'EstablishConnection') {
            this.mylog.message('receiving EstablishConnection');
            this._postEvent('LoginStatusChanged', 'EstablishConnection');
            this.wsConnected = true;
            this._systeminfo();
            return;
        }

        if (evnt === 'TerminateConnection') {
            this.mylog.message('receiving TerminateConnection');
            this._postEvent('LoginStatusChanged', 'TerminateConnection');
            this.wsConnected = false;
            this.ws.close();
            return;
        }

        if (!this.wsConnected) return;

        if (evnt === 'SystemInformation') {
            this.mylog.message(
                'receiving SystemInformation: ' +
                    jsonData.ProductName +
                    ' version: ' +
                    jsonData.ProductVersion,
            );
            this._postEvent(
                'SystemInformation',
                jsonData.ProductName + ' v. ' + jsonData.ProductVersion,
            );
            return;
        }

        if (evnt === 'SPLoggedIn') {
            this.mylog.message('receiving SPLoggedIn');
            this._postEvent('LoginStatusChanged', 'SPLoggedIn');
            this._postEvent('BLsPresent', -1);
            this.wsLoggedIn = true;
            return;
        }

        if (evnt === 'SPLoggedOut') {
            this.mylog.message('receiving SPLoggedOut');
            this._postEvent('LoginStatusChanged', 'SPLoggedOut');
            this._postEvent('BLsPresent', 0);
            this.wsLoggedIn = false;
            return;
        }

        if (this.wsLoggedIn) {
            if (callid === undefined)
                this.mylog.message('acknowledgement:' + evnt);
            else
                this.mylog.message(
                    'acknowledgement:' + evnt + ' callid:' + callid,
                );
        }
    };
    _notification = function (jsonData) {
        const evnt = jsonData.Event;
        const callid = jsonData.CallID;
        //mylog.message("notification:" + evnt + " callid:" +callid);

        if (evnt === 'SocketConnected') {
            this.mylog.message('receiving SocketConnected');
            this._postEvent('LoginStatusChanged', 'SocketConnected');
            this.start();
        } else if (evnt === 'HeadsetConnected') {
            this.mylog.message('receiving HeadsetConnected');
            this._postEvent('HeadsetConnected', jsonData.HeadsetName);
        } else if (evnt === 'HeadsetDisconnected') {
            this.mylog.message('receiving HeadsetDisconnected');
            this._postEvent('HeadsetDisconnected', jsonData.HeadsetName);
        } else if (evnt === 'MuteSoftphone') {
            this.mylog.message('receiving MuteSoftphone');
            this._postEvent('MuteMicrophone', true);
        } else if (evnt === 'UnmuteSoftphone') {
            this.mylog.message('receiving UnmuteSoftphone');
            this._postEvent('MuteMicrophone', false);
        } else if (evnt === 'InCallAccepted') {
            this.mylog.message('receiving InCallAccepted ' + callid);
            this._postEvent('AcceptCall', callid);
        } else if (evnt === 'InCallRejected') {
            this.mylog.message('receiving InCallRejected');
            this._postEvent('RejectCall', callid);
        } else if (evnt === 'CallEnded') {
            this.mylog.message('receiving CallEnded');
            this._postEvent('EndCall', callid);
        } else if (evnt === 'CallHold') {
            this.mylog.message('receiving CallHold');
            this._postEvent('HoldCall', callid);
        } else if (evnt === 'HeldCallResumed') {
            this.mylog.message('receiving HeldCallResumed');
            this._postEvent('ResumeCall', callid);
        } else if (evnt === 'ListenerClosed') {
            this.mylog.message('ListenerClosed received');
            this.SendTerminateEvent();
        } else if (evnt === 'BLsPresent') {
            this.mylog.message('receiving BLsPresent');
            this._postEvent('BLsPresent', jsonData.ablDevices);
        } else if (evnt === 'HeadsetAvailable') {
            this.mylog.message('receiving HeadsetAvailable');

            let data = {
                name: jsonData.HeadsetName,
                id: jsonData.HeadsetPath,
                serial: '',
                firmware: '',
                vid: '',
                pid: '',
            };

            this._postEvent('HeadsetAvailable', data);
        } else if (evnt === 'HeadsetRemoved') {
            this.mylog.message('receiving HeadsetRemoved');

            let data = {
                name: jsonData.HeadsetName,
                id: jsonData.HeadsetPath,
                serial: '',
                firmware: '',
                vid: '',
                pid: '',
            };

            this._postEvent('HeadsetRemoved', data);
        } else if (evnt === 'Redial') {
            this.mylog.message('receiving Redial');
            this._postEvent('Redial', 0);
        } else if (evnt === 'Offhook') {
            this.mylog.message('receiving Offhook');
            this._postEvent('Offhook', 0);
        } else if (evnt === 'InCallAcceptedOnOffhook') {
            this.mylog.message('receiving InCallAcceptedOnOffhook');
            this._postEvent('InCallAcceptedOnOffhook', jsonData);
        } else {
            this.mylog.error('Unhandled notification received ' + evnt);
        }
    };
    send = function (json) {
        if (!this.wsWorking) return;
        this.ws.send(JSON.stringify(json));
    };
    start = function () {
        this.mylog.message('sending EstablishConnection');
        const obj = {
            Event: 'EstablishConnection',
            EventType: 'Request',
            SPIconImage: 'SPImage.ico',
            AudioDeviceChangesSupport: 'Yes',
            DNDOption: 'Yes',
            MuteSupport: 'Yes',
            RedialSupport: 'No',
            OffHookSupport: 'No',
        };
        obj.SPName = 'Softphone::' + this.name;
        this.send(obj);
    };
    _systeminfo = function () {
        if (!this.wsWorking && this.webhidsdk !== null) {
            this._postEvent(
                'SystemInformation',
                'DSEA Call Control JS Library v. ' + _version_str,
            );
            return;
        }
        this.mylog.message('sending SystemInformation');
        this.send({
            Event: 'SystemInformation',
            EventType: 'Request',
        });
    };

    SendLoginEvent = function () {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.open();
            this._postEvent('LoginStatusChanged', 'SPLoggedInHID');
            this._systeminfo();
            return;
        }
        if (!this.wsConnected) return;
        this.mylog.message('sending SPLoggedIn');
        this.send({
            Event: 'SPLoggedIn',
            EventType: 'Request',
        });
    };
    SendLogoutEvent = function () {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.close();
            this._postEvent('LoginStatusChanged', 'SPLoggedOutHID');
            return;
        }
        if (!this.wsLoggedIn) return;
        this.mylog.message('sending SPLoggedOut');
        this.send({
            Event: 'SPLoggedOut',
            EventType: 'Request',
        });
    };
    SendTerminateEvent = function () {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.close();
            this._postEvent('LoginStatusChanged', 'TerminateConnection');
            return;
        }
        if (this.wsLoggedIn) this.SendLogoutEvent();
        if (!this.wsConnected) return;
        this.mylog.message('sending TerminateConnection');
        this.send({
            Event: 'TerminateConnection',
            EventType: 'Request',
        });
    };
    SendMuteStatus = function (mute) {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.mute(mute);
            return;
        }
        if (!this.wsLoggedIn) return;
        this.muteStatus = mute;
        if (this.muteStatus) {
            this.mylog.message('sending MuteHeadset');
            this.send({
                Event: 'MuteHeadset',
                EventType: 'Request',
            });
        } else {
            this.mylog.message('sending UnmuteHeadset');
            this.send({
                Event: 'UnmuteHeadset',
                EventType: 'Request',
            });
        }
    };
    SendIncomingCallEvent = function (callid) {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.incoming(callid);
            return;
        }

        if (!this.wsLoggedIn) return;
        this.mylog.message('sending IncomingCall ' + callid);
        this.send({
            Event: 'IncomingCall',
            EventType: 'Request',
            CallID: callid,
        });
    };
    SendOutgoingCallEvent = function (callid) {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this.webhidsdk.outgoing(callid);
            return;
        }

        if (!this.wsLoggedIn) return;
        this.mylog.message('sending OutgoingCall ' + callid);
        this.send({
            Event: 'OutgoingCall',
            EventType: 'Request',
            CallID: callid,
        });
    };
    SendEndCallEvent = function (callid) {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.end(callid);
            return;
        }

        if (!this.wsLoggedIn) return;
        this.mylog.message('sending CallEnded ' + callid);
        this.send({
            Event: 'CallEnded',
            EventType: 'Request',
            CallID: callid,
        });
    };
    SendHoldCallEvent = function (callid) {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.hold(callid);
            return;
        }

        if (!this.wsLoggedIn) return;
        this.mylog.message('sending CallHold ' + callid);
        this.send({
            Event: 'CallHold',
            EventType: 'Request',
            CallID: callid,
        });
    };
    SendUnholdCallEvent = function (callid) {
        if (!this.wsWorking && this._webhidsdk !== null) {
            //webhidsdk.unhold(callid); // Not implemented
            return;
        }

        if (!this.wsLoggedIn) return;
        this.mylog.message('sending HeldCallResumed ' + callid);
        this.send({
            Event: 'HeldCallResumed',
            EventType: 'Request',
            CallID: callid,
        });
    };
    SendActiveCallEvent = function (callid) {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.active(callid);
            return;
        }

        if (!this.wsLoggedIn) return;
        this.mylog.message('sending InCallAccepted');
        this.send({
            Event: 'InCallAccepted',
            EventType: 'Request',
            CallID: callid,
        });
    };
    SendPresenceEvent = function (state) {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.setBLPresence(state);
            return;
        }
        if (!this.wsLoggedIn) return;
        this.mylog.message('sending SendPresenceEvent ' + state);
        this.send({
            Event: 'SetPresence',
            EventType: 'Request',
            State: state,
        });
    };
    SendActiveDeviceChanged = function (supported, hs) {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.headset(hs);
            return;
        }
        if (!this.wsLoggedIn) return;
        let status = 1;
        if (!supported) status = 0;
        this.mylog.message('sending ActiveDeviceChanged ' + hs);
        this.send({
            Event: 'ActiveDeviceChanged',
            EventType: 'Request',
            HSSTATUS: status,
            HeadsetPath: hs,
        });
    };
    AllowHS = function () {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.select();
            return;
        }
    };
    AllowBL = function () {
        if (!this.wsWorking && this._webhidsdk !== null) {
            this._webhidsdk.selectBL();
            return;
        }
    };
}
function log(maincolor, secondarycolor) {
    let this_ = this;

    this_.active = true;
    this_.color1 = maincolor;
    this_.color2 = secondarycolor;

    const messageMax = 81;
    const reportMax = 40;

    const format =
        'padding: 3px;height: 18px; line-height: 18px;font-size: 12px;';
    const border = 'border:1px solid black;';
    const bordertlr =
        'border-top:1px solid black;border-left:1px solid black;border-right:1px solid black;';

    const ERRORCOLOR = 'Crimson';
    const INITCOLOR = 'Khaki';
    const CONNECTIONCOLOR = 'DarkKhaki';

    function brightness(r, g, b) {
        return Math.sqrt(r * r * 0.241 + g * g * 0.691 + b * b * 0.068);
    }
    this.activate = function (act = true) {
        this_.active = act;
    };
    this.image = function (url, size = 100) {
        if (!this_.active) return;
        var image = new Image();
        image.onload = function () {
            var style = [
                'font-size: 1px;',
                'border: 1px solid black;',
                'padding: ' + size + 'px ' + size + 'px;',
                'background: ' + this_.color2 + ' url(' + url + ') no-repeat;',
                'background-size: contain;',
            ].join(' ');
            console.log('%c ', style);
        };
        image.src = url;
    };
    this.led = function (msg, r, g, b) {
        if (!this_.active) return;

        while (msg.length < messageMax - 6) msg = msg + ' ';

        var args = [];
        args.push('%c   %c %c' + msg);
        args.push(
            format +
                'border: 1px solid black;border-radius: 50%;background: rgb(' +
                r +
                ',' +
                g +
                ',' +
                b +
                ')',
        );
        args.push(format);
        args.push(format + border + 'background:' + this_.color2 + ';');
        console.log.apply(this, args);
    };
    this.error = function (msg) {
        this.message(msg, ERRORCOLOR);
    };
    this.connection = function (msg) {
        this.message(msg, CONNECTIONCOLOR);
    };
    this.init = function (msg) {
        this.message(msg, INITCOLOR);
    };
    this.message = function (msg, color = '') {
        if (!this_.active) return;
        if (color === '') color = this_.color2;
        while (msg.length < messageMax) {
            msg = ' ' + msg;
            if (msg.length < messageMax) msg = msg + ' ';
        }

        console.log('%c' + msg, format + border + 'background:' + color + ';');
    };
    this.report = function (
        data,
        name,
        statename,
        headercolor = '',
        itemcolor = '',
    ) {
        if (!this_.active) return;
        if (headercolor === '') headercolor = this_.color1;
        if (itemcolor === '') itemcolor = this_.color2;
        var header = '%c' + name + ' (' + statename + ')';
        while (header.length < reportMax) header += ' ';
        for (i = 0; i < data.length; i++) {
            header += '%c\n';
            item = '%c ' + i + ' ' + data[i][0];
            while (item.length < reportMax - data[i][1].toString().length - 2)
                item += ' ';
            item += ' ' + data[i][1] + ' ';
            header += item;
        }

        margin = '';
        if (name.toUpperCase().substr(0, 5) === 'INPUT')
            margin = 'margin-left: 283px;';

        var args = [];
        args.push(header);
        args.push(
            format + bordertlr + margin + 'background:' + headercolor + ';',
        );
        for (j = 0; j < data.length; j++) {
            args.push('');
            if (j === data.length - 1)
                args.push(
                    format + border + margin + 'background:' + itemcolor + ';',
                );
            else
                args.push(
                    format +
                        bordertlr +
                        margin +
                        'background:' +
                        itemcolor +
                        ';',
                );
        }
        console.log.apply(this, args);
    };
    this.jsonreport = function (name, data) {
        if (!this_.active) return;

        var header = '%c' + name;
        while (header.length < messageMax + 2) header += ' ';

        cnt = 0;
        for (var key in data) {
            if (Array.isArray(data[key])) {
                if (key === 'configSettings')
                    for (var kk in data[key]) {
                        header += '%c\n';
                        line = data[key][kk]['FeatureName'];
                        while (line.length < (messageMax - 3) / 2)
                            line = ' ' + line;
                        line = ' ' + line;
                        line += ' : ';
                        y = 0;
                        str = data[key][kk].FeatureValue;
                        while (line.length < messageMax - 1)
                            if (y >= str.length) line += ' ';
                            else line += str[y++];
                        line += ' ';
                        header += '%c' + line;
                        cnt++;
                    }
            } else {
                header += '%c\n';
                line = key;
                while (line.length < (messageMax - 3) / 2) line = ' ' + line;
                line = ' ' + line;
                line += ' : ';
                y = 0;
                str = '';
                if (data[key] !== null) str = data[key].toString();
                while (line.length < messageMax - 1)
                    if (y >= str.length) line += ' ';
                    else line += str[y++];
                line += ' ';
                header += '%c' + line;
                cnt++;
            }
        }

        var args = [];
        args.push(header);
        args.push(format + bordertlr + 'background:' + this_.color1 + ';');
        for (j = 0; j < cnt; j++) {
            args.push('');
            if (j === cnt - 1)
                args.push(format + border + 'background:' + this_.color2 + ';');
            else
                args.push(
                    format + bordertlr + 'background:' + this_.color2 + ';',
                );
        }
        console.log.apply(this, args);
    };
}
function abl(loaded) {
    let this_ = this;
    this_.callback = loaded;

    const MYCOLOR1 = 'PaleVioletRed';
    const MYCOLOR2 = 'LightPink';

    const UBL20 = 0x0074;
    let myABLs = [];
    let mylog = null;

    this.presence = function (thecolor) {
        this_.color(thecolor, 1);
    };
    this.color = async function (thecolor, oc) {
        if (thecolor.length !== 7 || thecolor[0] !== '#') return;

        colordec = parseInt(thecolor.replace('#', '0x'));
        r = (colordec & 0xff0000) >> 16;
        g = (colordec & 0x00ff00) >> 8;
        b = (colordec & 0x0000ff) >> 0;
        buffer = new Uint8Array(63);
        buffer.fill(0);
        x = 0;
        //buffer[x++] = 1;
        buffer[x++] = 18;
        buffer[x++] = 2;

        buffer[x++] = r;
        buffer[x++] = g;
        buffer[x++] = b;

        buffer[x++] = r;
        buffer[x++] = g;
        buffer[x++] = b;

        buffer[x++] = oc;
        buffer[x++] = 0xff; //Flash count
        buffer[x++] = 0xff;
        buffer[x++] = 0xff;
        buffer[x++] = 0xff;

        if (oc === 2) {
            buffer[x++] = 0; //on time
            buffer[x++] = 4;

            buffer[x++] = 0; //off time
            buffer[x++] = 4;
        }

        for (i = 0; i < myABLs.length; i++) {
            if (myABLs[i].device.opened) {
                myABLs[i].device.sendReport(1, buffer).catch(function (error) {
                    mylog.error('Error in SendReport abl::color ' + error);
                });
            }
        }
    };
    this.select = async function () {
        if (!navigator.hid) {
            alert(
                'navigator.hid not defined - Use Chrome 89+ or install EPOS Connect',
            );
            return;
        }

        filters = [{ vendorId: EPOSVID, productId: UBL20 }];
        device = await navigator.hid.requestDevice({ filters: filters });
        if (device.length === 0) return;
        dev = device[0];
        found = false;
        for (i = 0; i < myABLs.length; i++)
            if (dev === myABLs[i].device) found = true;
        if (found) return;
        mylog.message('Adding device ' + dev.productName);

        addDevice(dev);
    };
    this.play = function (tone, mode, repetition) {
        buffer = new Uint8Array(63);
        buffer.fill(0);
        x = 0;
        //buffer[x++] = 1;
        buffer[x++] = 9;
        buffer[x++] = 4;

        buffer[x++] = tone;
        buffer[x++] = mode;
        buffer[x++] = (repetition & 0x000000ff) >> 0;
        buffer[x++] = (repetition & 0x0000ff00) >> 8;
        buffer[x++] = (repetition & 0x00ff0000) >> 16;
        buffer[x++] = (repetition & 0xff000000) >> 24;

        for (i = 0; i < myABLs.length; i++) {
            if (myABLs[i].device.opened) {
                buffer[2] = myABLs[i].ringtone;
                myABLs[i].device.sendReport(1, buffer).catch(function (error) {
                    mylog.error('Error in SendReport abl::play ' + error);
                });
            }
        }
    };
    this.open = async function () {
        await init();
        this_.callback('loaded');
    };
    this.close = async function () {
        this_.color('#000000', 1);
        for (i = myABLs.length - 1; i >= 0; i--) {
            if (myABLs[i].device.opened) {
                mylog.message('Device removed ' + myABLs[i].device.productName);
                myABLs[i].device.close();
                myABLs.splice(i, 1);
            }
        }
        myABLs = [];
        this_.callback('devices', 0);
    };
    function onInputReport(event) {
        inputReportBuffer = new Uint8Array(event.data.buffer);
        len = parseInt(inputReportBuffer[0]);
        cmd = parseInt(inputReportBuffer[1]);

        if (cmd === 1) {
            if (inputReportBuffer[27] & 8) {
                for (i = 0; i < myABLs.length; i++) {
                    if (myABLs[i].device == event.device) {
                        myABLs[i].ringtone = 3;
                    }
                }
            }
        }
    }

    if (navigator.hid) {
        navigator.hid.addEventListener('connect', async ({ device }) => {
            if (device.productId === UBL20) {
                mylog.connection(`HID connected: ${device.productName}`);
                addDevice(device);
            }
        });
        navigator.hid.addEventListener('disconnect', ({ device }) => {
            if (device.productId === UBL20) {
                mylog.connection(`HID disconnected: ${device.productName}`);
                for (i = 0; i < myABLs.length; i++) {
                    if (myABLs[i].device === device) {
                        mylog.message('Device removed ' + device.productName);
                        myABLs[i].device.close();
                        myABLs.splice(i, 1);
                        this_.callback('devices', myABLs.length);
                        return;
                    }
                }
            }
        });
    }

    function status(dev) {
        buffer = new Uint8Array(63);
        buffer.fill(0);
        x = 0;
        buffer[x++] = 3;
        buffer[x++] = 1;
        dev.sendReport(1, buffer).catch(function (error) {
            console.log('Error in status ' + error);
        });
    }

    const addDevice = async function (dev) {
        if (dev.productId !== UBL20) return;

        dev.open().then(function () {
            if (dev.opened) {
                let device = {};
                device.device = dev;
                device.serial = '';
                device.firmware = '';
                device.wait = 0;
                device.number = myABLs.length;
                device.vid = parseInt(EPOSVID);
                device.pid = parseInt(UBL20);
                device.id = getDeviceID(dev);
                device.ringtone = 0;
                myABLs.push(device);
                this_.callback('devices', myABLs.length);
                this_.color('#000000', 1);

                dev.oninputreport = onInputReport;
                status(dev);
            }
        });
    };

    const init = async function () {
        if (navigator.hid) {
            let devices = await navigator.hid.getDevices();

            const promises = await devices.map(async (dev) => {
                const numFruit = await addDevice(dev);
                return numFruit;
            });
            await Promise.all(promises);
        }
    };
    mylog = new log(MYCOLOR1, MYCOLOR2);
}
function webhid(brand = '', name = '', version = '') {
    let this_ = this;
    this_.name = name;
    this_.brand = brand;
    this_.version = version;
    //helper for writing to the console
    let mylog = null;

    //Colors for the console logging
    const MYCOLOR1 = 'LightSkyBlue';
    const MYCOLOR2 = 'LightBlue';

    //helper for managing connected ABL devices
    let myabl = null;
    //Presence color in #rrggbb format
    let presence = '';
    let firstring = true;

    //current headset
    let myHSs = [];
    let deviceIsSupported = true;

    //mute status of current headset
    let mute = false;
    //all current calls
    //map from callid to json
    //state : none,incoming,outgoing,active,onhold
    //created: seconds since 1970. used as incoming calls are answer FIFO
    //active: seconds since 1970. used as held calls are unheld LIFO
    //type: incoming, outgoing, other
    let calls = new Map();

    const led_vendor_bit3 = 0b10000000;

    //all access to headset through the main and alternate vendor pages
    const VENDORPAGE = 0xffff;
    const ALTVENDORPAGE = 0xff58;
    const ALTVENDORPAGE2 = 0xff58;

    //12 states of call control
    const IDLE = 0;
    const INCOMING = 1;
    const HOLDING = 2;
    const INCOMING_HOLDING = 3;
    const OUTGOING = 4;
    const OUTGOING_INCOMING = 5;
    const OUTGOING_HOLDING = 6;
    const OUTGOING_INCOMING_HOLDING = 7;
    const ACTIVE = 8;
    const ACTIVE_INCOMING = 9;
    const ACTIVE_HOLDING = 10;
    const ACTIVE_INCOMING_HOLDING = 11;
    const UNKNOWN = 12;
    //create or change a call into incoming state - sdk accepts as unlimited number of calls in incoming state. incoming calls are answer FIFO
    this.incoming = function (callid) {
        if (!calls.has(String(callid)))
            calls.set(String(callid), {
                state: 'none',
                created: Date.now(),
                active: 0,
                type: 'incoming',
                started: new Date(),
            });
        else if (calls.get(String(callid)).state === 'incoming') return;

        calls.get(String(callid)).state = 'incoming';
        updateHeadset();
    };

    //create or change a call into outgoing state - sdk accepts maximum 1 outgoing or active call at the time
    this.outgoing = function (callid) {
        if (!calls.has(String(callid)))
            calls.set(String(callid), {
                state: 'none',
                created: Date.now(),
                active: 0,
                type: 'outgoing',
                started: new Date(),
            });
        else if (calls.get(String(callid)).state === 'outgoing') return;
        for (let key of calls.keys()) {
            if (key !== String(callid)) {
                if (calls.get(key).state === 'outgoing') {
                    calls.delete(String(key));
                    postEvent('EndCall', key);
                } else if (calls.get(key).state === 'active') {
                    calls.get(key).state = 'onhold';
                    postEvent('HoldCall', key);
                }
            }
        }

        calls.get(String(callid)).state = 'outgoing';
        updateHeadset();
    };
    //create or change a call into active state - sdk accepts maximum 1 active or outgoing call at the time
    this.active = function (callid) {
        if (!calls.has(String(callid)))
            calls.set(String(callid), {
                state: 'none',
                created: Date.now(),
                active: 0,
                type: 'other',
                started: new Date(),
            });
        else if (calls.get(String(callid)).state === 'active') return;

        for (let key of calls.keys()) {
            if (key !== String(callid)) {
                if (calls.get(key).state == 'outgoing') {
                    calls.delete(String(key));
                    postEvent('EndCall', key);
                } else if (calls.get(key).state == 'active') {
                    calls.get(key).state = 'onhold';
                    postEvent('HoldCall', key);
                }
            }
        }

        calls.get(String(callid)).state = 'active';
        calls.get(String(callid)).active = Date.now();
        updateHeadset();
    };
    //create or change a call into onhold state - sdk accepts unlimited number of call on hold.
    this.hold = function (callid) {
        if (!calls.has(String(callid)))
            calls.set(String(callid), {
                state: 'none',
                created: Date.now(),
                active: Date.now(),
                type: 'other',
                started: new Date(),
            });
        else if (calls.get(String(callid)).state === 'onhold') return;

        calls.get(String(callid)).state = 'onhold';
        updateHeadset();
    };

    //ends a call
    this.end = function (callid) {
        if (calls.has(String(callid))) {
            calls.delete(String(callid));
            updateHeadset();
        }
    };
    async function setTheDefaultHeadset() {
        initHeadset();
    }
    async function finddevices() {
        myabl.open();
        await initHeadsetList();
        setTimeout(setTheDefaultHeadset, 2000);
    }
    //opens the sdk, call upon login
    this.open = async function () {
        finddevices();
    };

    //closes the sdk, please call upon window.onbeforeunload
    this.close = function () {
        closeHeadsetList();
        myabl.close();
    };

    //manipulates the mute state of the headset
    this.mute = function (ismute) {
        mute = ismute;
        updateHeadset();
    };

    //display the webHID device dialog for device selection
    this.select = async function () {
        if (!navigator.hid) {
            alert(
                'navigator.hid not defined - Use Chrome 89+ or install EPOS Connect',
            );
            return;
        }

        filters = [
            { usagePage: VENDORPAGE, vendorId: EPOSVID },
            { usagePage: ALTVENDORPAGE, vendorId: EPOSVID },
            { usagePage: ALTVENDORPAGE2, vendorId: EPOSVID },
        ];
        //filters = [{vendorId: EPOSVID}];
        devices = await navigator.hid.requestDevice({ filters: filters });
        if (devices.length === 0) return;

        dev = devices[0];

        //console.log(dev);

        for (i = 0; i < myHSs.length; i++) if (myHSs[i].device === dev) break;

        deviceIsSupported = true;

        if (i === myHSs.length) {
            //all new device
            await addNewHeadset(dev);
        } else if (i > 0) {
            //anden fra listen
            myHSs.splice(0, 0, myHSs.splice(i, 1)[0]);
        } else return; //allerede current

        initHeadset();
    };

    //Function to retreive and report info of device
    function reportAvailability(headset) {
        mylog.message('New device available ' + headset.name);

        let data = {
            name: headset.name,
            id: headset.id,
            serial: headset.serial,
            firmware: headset.firmware,
            vid: headset.vid,
            pid: headset.pid,
        };
        postEvent('HeadsetAvailable', data);
    }
    //Function to select new default device
    this.headset = async function (devname) {
        console.log(devname);
        for (i = 0; i < myHSs.length; i++) {
            console.log(i + ' ' + myHSs[i].name);
            if (myHSs[i].name === devname) {
                deviceIsSupported = true;
                if (i !== 0)
                    //anden fra listen
                    myHSs.splice(0, 0, myHSs.splice(i, 1)[0]);
                initHeadset();
                mylog.message('New device selected ' + myHSs[0].name);
                return;
            }
        }

        //Softphone gchanged to a non EPOS device
        mylog.message('Non EPOS device selected ' + devname);
        if (myHSs.length) postEvent('HeadsetDisconnected', myHSs[0].name);
        deviceIsSupported = false;
    };

    //display the webHID device dialog to select ABL device
    this.selectBL = function () {
        myabl.select();
    };

    //sets the presence color of the ABL - presence color is used when not in a call
    this.setBLPresence = function (hex) {
        hex = hex.toUpperCase();
        presence = hex;
        updateHeadset();
    };

    //function to format HID reports for console logging
    function logInputReport(statename, byte) {
        let report = [
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
        ];

        for (i = 0; i < 8; i++) {
            if (myHSs[0].telephony_hook === 1 << i) {
                report[i][0] = 'Hook';
                if ((byte & myHSs[0].telephony_hook) > 0) report[i][1] = 1;
            }
            if (myHSs[0].telephony_flash === 1 << i) {
                report[i][0] = 'Flash';
                if ((byte & myHSs[0].telephony_flash) > 0) report[i][1] = 1;
            }
            if (myHSs[0].telephony_redial === 1 << i) {
                report[i][0] = 'Redial';
                if ((byte & myHSs[0].telephony_redial) > 0) report[i][1] = 1;
            }
            if (myHSs[0].telephony_mute === 1 << i) {
                report[i][0] = 'Mute';
                if ((byte & myHSs[0].telephony_mute) > 0) report[i][1] = 1;
            }
            if (myHSs[0].telephony_drop === 1 << i) {
                report[i][0] = 'Drop';
                if ((byte & myHSs[0].telephony_drop) > 0) report[i][1] = 1;
            }
        }

        mylog.report(
            report,
            'Input Report ' + myHSs[0].inputReportID,
            statename,
        );
    }
    function logOutputReport(statename, byte) {
        let report = [
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
            ['', 0],
        ];

        for (i = 0; i < 8; i++) {
            if (myHSs[0].led_offhook === 1 << i) {
                report[i][0] = 'Offhook';
                if ((byte & myHSs[0].led_offhook) > 0) report[i][1] = 1;
            }
            if (myHSs[0].led_microphone === 1 << i) {
                report[i][0] = 'Microphone';
                if ((byte & myHSs[0].led_microphone) > 0) report[i][1] = 1;
            }
            if (myHSs[0].led_ring === 1 << i) {
                report[i][0] = 'Ring';
                if ((byte & myHSs[0].led_ring) > 0) report[i][1] = 1;
            }
            if (myHSs[0].led_ringer === 1 << i) {
                report[i][0] = 'Ringer';
                if ((byte & myHSs[0].led_ringer) > 0) report[i][1] = 1;
            }
            if (myHSs[0].led_mute === 1 << i) {
                report[i][0] = 'Mute';
                if ((byte & myHSs[0].led_mute) > 0) report[i][1] = 1;
            }
            if (myHSs[0].led_online === 1 << i) {
                report[i][0] = 'Online';
                if ((byte & myHSs[0].led_online) > 0) report[i][1] = 1;
            }
            if (myHSs[0].led_hold === 1 << i) {
                report[i][0] = 'Hold';
                if ((byte & myHSs[0].led_hold) > 0) report[i][1] = 1;
            }
            if (led_vendor_bit3 === 1 << i) {
                report[i][0] = 'Vendor Page';
                if ((byte & led_vendor_bit3) > 0) report[i][1] = 1;
            }
        }

        mylog.report(
            report,
            'Output Report ' + myHSs[0].outputReportID,
            statename,
        );
    }

    const addNewHeadset = async function (dev) {
        found = false;
        for (x = 0; x < dev.collections.length; x++)
            if (
                dev.vendorId === EPOSVID &&
                (dev.collections[x].usagePage === VENDORPAGE ||
                    dev.collections[x].usagePage === ALTVENDORPAGE ||
                    dev.collections[x].usagePage === ALTVENDORPAGE2)
            )
                found = true;
        if (!found) {
            return;
        }

        await dev.open();
        if (!dev.opened) return;

        dev.oninputreport = onInputReport;
        let headset = {};
        headset.device = dev;
        headset.serial = '';
        headset.firmware = '';
        headset.vid = parseInt(EPOSVID);
        headset.pid = parseInt(dev.productId);
        headset.id = getDeviceID(dev);
        headset.name = getDeviceName(dev);
        headset.slave1id = '';
        headset.slave1name = '';
        headset.slave1firmware = '';
        headset.slave1serial = '';
        headset.slave2id = '';
        headset.slave2name = '';
        headset.slave2firmware = '';
        headset.slave2serial = '';
        headset.slave1pid = 0;
        headset.slave2pid = 0;
        headset.Commands = [];
        headset.inputReportID = 0;
        headset.outputReportID = 0;
        headset.telephony_hook = 0;
        headset.telephony_flash = 0;
        headset.telephony_redial = 0;
        headset.telephony_mute = 0;
        headset.telephony_drop = 0;
        headset.led_ringer = 0; //0b00000001;
        headset.led_offhook = 0; //0b00000010;
        headset.led_microphone = 0; //0b00000100;
        headset.led_ring = 0; //0b00001000;
        headset.led_mute = 0; //0b00010000;
        headset.led_online = 0; //0b00100000;
        headset.led_hold = 0; //0b01000000;

        myHSs.unshift(headset);
        initWEBHIDheadset();
        if (deviceIsSupported) {
            mylog.message('New device selected ' + headset.name);
            postEvent('HeadsetConnected', headset.name);
        }
        reportAvailability(headset);
    };

    //function to search for EPOS headset and pick the right one
    async function initHeadsetList() {
        if (!navigator.hid) return;

        let devices = await navigator.hid.getDevices();
        const promises = await devices.map(async (dev) => {
            const numFruit = await addNewHeadset(dev);
            return numFruit;
        });
        await Promise.all(promises);
    }
    //function for initializing current headset
    async function initHeadset() {
        if (myHSs.length === 0) {
            mylog.message('No headset connected');
            return;
        }
        if (deviceIsSupported) {
            mylog.message('Device in use by SDK is: ' + myHSs[0].name);
            postEvent('HeadsetConnected', myHSs[0].name);
        }

        updateHeadset();
    }

    //function to analyze telephony collection of current headset
    async function initWEBHIDheadset() {
        let telephonyCollection = null;
        for (x = 0; x < myHSs[0].device.collections.length; x++) {
            if (myHSs[0].device.collections[x].usagePage === VENDORPAGE)
                telephonyCollection = myHSs[0].device.collections[x];
        }

        if (telephonyCollection === null) {
            //For MODI....
            for (x = 0; x < myHSs[0].device.collections.length; x++) {
                if (myHSs[0].device.collections[x].usagePage === ALTVENDORPAGE)
                    telephonyCollection = myHSs[0].device.collections[x];
            }
        }

        if (telephonyCollection === null) {
            //This should never happen
            mylog.error(
                'Device does not have Telephony Collection, using defaults',
            );
            return;
        }
        //console.log(myHSs[0].device);

        let outputSetup = [];
        for (q = 0; q < telephonyCollection.outputReports.length; q++) {
            reportPos = 0;
            for (
                x = 0;
                x < telephonyCollection.outputReports[q].items.length;
                x++
            ) {
                for (
                    y = 0;
                    y <
                    telephonyCollection.outputReports[q].items[x].usages.length;
                    y++
                ) {
                    usagePage =
                        (telephonyCollection.outputReports[q].items[x].usages[
                            y
                        ] &
                            0xff0000) >>
                        16;
                    usage =
                        telephonyCollection.outputReports[q].items[x].usages[
                            y
                        ] & 0x0000ff;
                    if (usagePage === 0x95) {
                        myHSs[0].outputReportID =
                            telephonyCollection.outputReports[q].reportId;
                        switch (usage) {
                            case 0x09: //'led-mute'
                                myHSs[0].led_mute = 1 << reportPos;
                                outputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x17: //'led-offhook'
                                myHSs[0].led_offhook = 1 << reportPos;
                                outputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x9e: //'led-ringer'
                                myHSs[0].led_ringer = 1 << reportPos;
                                outputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x18: //'led-ring'
                                myHSs[0].led_ring = 1 << reportPos;
                                outputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x20: //'led-hold'
                                myHSs[0].led_hold = 1 << reportPos;
                                outputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x21: //'led-microphone'
                                myHSs[0].led_microphone = 1 << reportPos;
                                outputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x2a: //'led-online'
                                myHSs[0].led_online = 1 << reportPos;
                                outputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            default:
                                break;
                        }
                    } else if (usagePage === 0x13) {
                        switch (usage) {
                            case 0x9e: //'led-ringer'
                                myHSs[0].led_ringer = 1 << reportPos;
                                outputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            default:
                                break;
                        }
                    }
                    reportPos +=
                        telephonyCollection.outputReports[q].items[x]
                            .reportSize;
                }
            }
        }
        mylog.report(outputSetup, 'Output', myHSs[0].outputReportID);

        let inputSetup = [];
        for (q = 0; q < telephonyCollection.inputReports.length; q++) {
            reportPos = 0;
            for (
                x = 0;
                x < telephonyCollection.inputReports[q].items.length;
                x++
            ) {
                for (
                    y = 0;
                    y <
                    telephonyCollection.inputReports[q].items[x].usages.length;
                    y++
                ) {
                    usagePage =
                        (telephonyCollection.inputReports[q].items[x].usages[
                            y
                        ] &
                            0xff0000) >>
                        16;
                    usage =
                        telephonyCollection.inputReports[q].items[x].usages[y] &
                        0x0000ff;

                    if (usagePage === 0x13) {
                        myHSs[0].inputReportID =
                            telephonyCollection.inputReports[q].reportId;
                        switch (usage) {
                            case 0x20: //telephony-hook'
                                myHSs[0].telephony_hook = 1 << reportPos;
                                inputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x21: //telephony-flash'
                                myHSs[0].telephony_flash = 1 << reportPos;
                                inputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x24: //telephony-redial'
                                myHSs[0].telephony_redial = 1 << reportPos;
                                inputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x2f: //telephony-mute'
                                myHSs[0].telephony_mute = 1 << reportPos;
                                inputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            case 0x26: //telephony-drop'
                                myHSs[0].telephony_drop = 1 << reportPos;
                                inputSetup.push([
                                    dec2hexString(usagePage),
                                    dec2hexString(usage),
                                ]);
                                break;
                            default:
                                break;
                        }
                    }

                    reportPos +=
                        telephonyCollection.inputReports[q].items[x].reportSize;
                }
            }
        }
        mylog.report(inputSetup, 'Input', myHSs[0].inputReportID);
    }

    //function to write current state to headset and ABL devices
    async function updateHeadset() {
        let state = getState();
        byte = 0;

        if (state === INCOMING) {
            myabl.color('#FF0000', 2);
            byte |= myHSs[0].led_ring | myHSs[0].led_ringer;
        } else if (state === ACTIVE) {
            myabl.color('#FF0000', 1);
            byte |= myHSs[0].led_offhook;
        } else if (state === ACTIVE_HOLDING) {
            myabl.color('#FF0000', 1);
            byte |= myHSs[0].led_offhook | myHSs[0].led_hold;
        } else if (state === ACTIVE_INCOMING) {
            myabl.color('#FF0000', 2);
            byte |=
                myHSs[0].led_offhook | myHSs[0].led_ring | myHSs[0].led_ringer;
        } else if (state === ACTIVE_INCOMING_HOLDING) {
            myabl.color('#FF0000', 2);
            byte |=
                myHSs[0].led_offhook |
                myHSs[0].led_ring |
                myHSs[0].led_hold |
                myHSs[0].led_ringer;
        } else if (state === OUTGOING) {
            myabl.color('#FF0000', 1);
            byte |= myHSs[0].led_offhook;
        } else if (state === OUTGOING_HOLDING) {
            myabl.color('#FF0000', 1);
            byte |= myHSs[0].led_offhook | myHSs[0].led_hold;
        } else if (state === OUTGOING_INCOMING) {
            myabl.color('#FF0000', 2);
            byte |=
                myHSs[0].led_offhook | myHSs[0].led_ring | myHSs[0].led_ringer;
        } else if (state === OUTGOING_INCOMING_HOLDING) {
            myabl.color('#FF0000', 2);
            byte |=
                myHSs[0].led_offhook |
                myHSs[0].led_ring |
                myHSs[0].led_hold |
                myHSs[0].led_ringer;
        } else if (state === HOLDING) {
            myabl.color('#FF0000', 1);
            byte |= myHSs[0].led_hold;
        } else if (state === INCOMING_HOLDING) {
            myabl.color('#FF0000', 2);
            byte |= myHSs[0].led_ring | myHSs[0].led_hold | myHSs[0].led_ringer;
        } else {
            //IDLE or UNKNOWN
            if (presence != '') {
                myabl.presence(presence); //if no presence
            } else {
                myabl.color('#00FF00', 1);
            }
        }

        if (mute) {
            byte |= myHSs[0].led_mute | myHSs[0].led_microphone;
        }
        byte |= led_vendor_bit3;

        if (myHSs.length !== 0) {
            if (myHSs[0].outputReportID > 0 && deviceIsSupported) {
                logOutputReport(getStateName(state), byte);
                myHSs[0].device
                    .sendReport(myHSs[0].outputReportID, new Uint8Array([byte]))
                    .catch(function (error) {
                        mylog.error(
                            'Error in SendReport webhid::updatehs ' + error,
                        );
                    });
            }
        }
        if (state === INCOMING || state === INCOMING_HOLDING) {
            if (firstring) {
                firstring = false;
                myabl.play(0, 3, 1);
            }
        } else {
            firstring = true;
            myabl.play(0, 0, 0);
        }
    }

    //close current headset
    function closeHeadsetList() {
        if (myHSs.length === 0) return;

        if (deviceIsSupported) postEvent('HeadsetDisconnected', myHSs[0].name);

        for (i = 0; i < myHSs.length; i++) {
            myHSs[i].device
                .sendReport(myHSs[0].outputReportID, new Uint8Array([0]))
                .catch(function (error) {
                    mylog.error(
                        'Error in SendReport webhid::closehslist ' + error,
                    );
                });
            myHSs[i].device.close();
            myHSs[i].device.oninputreport = null;
        }
        myHSs = [];
    }

    //functions for call control
    function endActive() {
        for (let key of calls.keys()) {
            if (calls.get(key).state === 'active') {
                postEvent('EndCall', key);
            }
        }
    }
    function endOutgoing() {
        for (let key of calls.keys()) {
            if (calls.get(key).state === 'outgoing') {
                postEvent('RejectCall', key);
            }
        }
    }
    function onholdActive() {
        for (let key of calls.keys()) {
            if (calls.get(key).state === 'active') postEvent('HoldCall', key);
        }
    }
    function endOldestCallIncoming() {
        oldest = Date.now();
        id = '';
        for (let key of calls.keys()) {
            if (calls.get(key).state === 'incoming') {
                if (calls.get(key).created < oldest) {
                    oldest = calls.get(key).created;
                    id = key;
                }
            }
        }
        if (id !== '') {
            postEvent('RejectCall', id);
        }
    }
    function activateOldestCallIncoming() {
        oldest = Date.now();
        id = '';
        for (let key of calls.keys()) {
            if (calls.get(key).state === 'incoming') {
                if (calls.get(key).created < oldest) {
                    oldest = calls.get(key).created;
                    id = key;
                }
            }
        }
        if (id !== '') {
            postEvent('AcceptCall', id);
        }
    }
    function activateOldestCallOnhold() {
        oldest = Date.now();
        id = '';
        for (let key of calls.keys()) {
            if (calls.get(key).state === 'onhold') {
                if (calls.get(key).active < oldest) {
                    oldest = calls.get(key).active;
                    id = key;
                }
            }
        }
        if (id !== '') {
            postEvent('ResumeCall', id);
        }
    }
    var lastrec = 0;
    //function for receiving HID reports from headset
    function onInputReport(event) {
        let reportId = event.reportId;
        let reportData = event.data;
        let rec = reportData.getUint8(0);

        if (event.device !== myHSs[0].device) return;

        state = getState();

        if (reportId === myHSs[0].inputReportID) {
            logInputReport(getStateName(state), rec);

            if (
                (lastrec & myHSs[0].telephony_mute) > 0 &&
                (rec & myHSs[0].telephony_mute) === 0
            ) {
                mylog.message('MUTE');
                mute = !mute;
                postEvent('MuteMicrophone', mute);
            }
            if (
                (lastrec & myHSs[0].telephony_redial) > 0 &&
                (rec & myHSs[0].telephony_redial) === 0
            ) {
                mylog.message('REDIAL');
                postEvent('Redial', 0);
            }
            if (
                (lastrec & myHSs[0].telephony_flash) > 0 &&
                (rec & myHSs[0].telephony_flash) === 0
            ) {
                mylog.message('FLASH');
                if (state === ACTIVE) onholdActive();
                else if (
                    state === HOLDING ||
                    state === INCOMING_HOLDING ||
                    state === ACTIVE_HOLDING ||
                    state === OUTGOING_HOLDING ||
                    state === ACTIVE_INCOMING_HOLDING ||
                    state === OUTGOING_INCOMING_HOLDING
                ) {
                    activateOldestCallOnhold();
                } else mylog.message('IGNORED');
            }
            if (
                (lastrec & myHSs[0].telephony_drop) > 0 &&
                (rec & myHSs[0].telephony_drop) === 0
            ) {
                mylog.message('DROP');
                if (
                    state === ACTIVE_INCOMING ||
                    state === ACTIVE_INCOMING_HOLDING ||
                    state === OUTGOING_INCOMING ||
                    state === OUTGOING_INCOMING_HOLDING ||
                    state === INCOMING ||
                    state === INCOMING_HOLDING
                )
                    endOldestCallIncoming();
                else mylog.message('IGNORED');
            }
            if (
                (lastrec & myHSs[0].telephony_hook) === 0 &&
                (rec & myHSs[0].telephony_hook) > 0
            ) {
                mylog.message('HOOK OFF');
                if (state === IDLE) {
                    postEvent('Offhook', myHSs[0].name);
                } else if (state === HOLDING) {
                    activateOldestCallOnhold();
                } else if (
                    state === ACTIVE_INCOMING ||
                    state === ACTIVE_INCOMING_HOLDING ||
                    state === OUTGOING_INCOMING ||
                    state === OUTGOING_INCOMING_HOLDING ||
                    state === INCOMING ||
                    state === INCOMING_HOLDING
                ) {
                    activateOldestCallIncoming();
                } else mylog.message('IGNORED');
            }
            if (
                (lastrec & myHSs[0].telephony_hook) > 0 &&
                (rec & myHSs[0].telephony_hook) === 0
            ) {
                mylog.message('HOOK ON');
                if (
                    state === ACTIVE ||
                    state === ACTIVE_HOLDING ||
                    state === ACTIVE_INCOMING ||
                    state === ACTIVE_INCOMING_HOLDING
                ) {
                    endActive();
                } else if (
                    state === OUTGOING ||
                    state === OUTGOING_HOLDING ||
                    state === OUTGOING_INCOMING ||
                    state === OUTGOING_INCOMING_HOLDING
                ) {
                    endOutgoing();
                } else mylog.message('IGNORED');
            }

            lastrec = rec;
        } else {
            let str = '';
            for (let i = 0; i < reportData.length; i++)
                str += dec2hexString(reportData.getUint8(i)) + ', ';
            //mylog.error("Input Report on wrong ID: " + reportId + " : " + str);
        }
    }
    //functions to compute current state based on calls variable
    function getStateName(state) {
        switch (state) {
            case IDLE:
                return 'IDLE';
            case INCOMING:
                return 'INCOMING';
            case HOLDING:
                return 'HOLDING';
            case INCOMING_HOLDING:
                return 'INCOMING_HOLDING';
            case OUTGOING:
                return 'OUTGOING';
            case OUTGOING_INCOMING:
                return 'OUTGOING_INCOMING';
            case OUTGOING_HOLDING:
                return 'OUTGOING_HOLDING';
            case OUTGOING_INCOMING_HOLDING:
                return 'OUTGOING_INCOMING_HOLDING';
            case ACTIVE:
                return 'ACTIVE';
            case ACTIVE_INCOMING:
                return 'ACTIVE_INCOMING';
            case ACTIVE_HOLDING:
                return 'ACTIVE_HOLDING';
            case ACTIVE_INCOMING_HOLDING:
                return 'ACTIVE_INCOMING_HOLDING';
            default:
                return 'UNKNOWN';
        }
    }
    function getState() {
        let incoming = 0;
        let outgoing = 0;
        let active = 0;
        let onhold = 0;
        for (let key of calls.keys()) {
            if (calls.get(key).state == 'incoming') incoming++;
            if (calls.get(key).state == 'outgoing') outgoing++;
            if (calls.get(key).state == 'active') active++;
            if (calls.get(key).state == 'onhold') onhold++;
        }
        if (incoming > 0 && outgoing === 0 && active === 0 && onhold === 0)
            return INCOMING;
        else if (incoming > 0 && outgoing === 0 && active === 0 && onhold > 0)
            return INCOMING_HOLDING;
        else if (
            incoming === 0 &&
            outgoing === 0 &&
            active === 1 &&
            onhold === 0
        )
            return ACTIVE;
        else if (incoming === 0 && outgoing === 0 && active === 1 && onhold > 0)
            return ACTIVE_HOLDING;
        else if (incoming > 0 && outgoing === 0 && active === 1 && onhold === 0)
            return ACTIVE_INCOMING;
        else if (incoming > 0 && outgoing === 0 && active === 1 && onhold > 0)
            return ACTIVE_INCOMING_HOLDING;
        else if (
            incoming === 0 &&
            outgoing === 1 &&
            active === 0 &&
            onhold === 0
        )
            return OUTGOING;
        else if (incoming === 0 && outgoing === 1 && active === 0 && onhold > 0)
            return OUTGOING_HOLDING;
        else if (incoming > 0 && outgoing === 1 && active === 0 && onhold === 0)
            return OUTGOING_INCOMING;
        else if (incoming > 0 && outgoing === 1 && active === 0 && onhold > 0)
            return OUTGOING_INCOMING_HOLDING;
        else if (incoming === 0 && outgoing === 0 && active === 0 && onhold > 0)
            return HOLDING;
        else if (
            incoming === 0 &&
            outgoing === 0 &&
            active === 0 &&
            onhold === 0
        )
            return IDLE;
        else return UNKNOWN;
    }
    //event listeners for connect/disconnect
    if (navigator.hid) {
        navigator.hid.addEventListener('connect', async ({ device }) => {
            setTimeout(async function () {
                //to let collections populate
                for (let x = 0; x < device.collections.length; x++) {
                    if (
                        device.vendorId === EPOSVID &&
                        (device.collections[x].usagePage === VENDORPAGE ||
                            device.collections[x].usagePage === ALTVENDORPAGE ||
                            device.collections[x].usagePage === ALTVENDORPAGE2)
                    ) {
                        mylog.connection(
                            'HID connected: ' + getDeviceName(device),
                        );
                        await addNewHeadset(device);
                        await initHeadset();
                        break;
                    }
                }
            }, 1000);
        });
        navigator.hid.addEventListener('disconnect', async ({ device }) => {
            for (let x = 0; x < device.collections.length; x++) {
                if (
                    device.vendorId === EPOSVID &&
                    (device.collections[x].usagePage === VENDORPAGE ||
                        device.collections[x].usagePage === ALTVENDORPAGE ||
                        device.collections[x].usagePage === ALTVENDORPAGE2)
                ) {
                    for (let i = 0; i < myHSs.length; i++) {
                        if (myHSs[i].device === device) {
                            mylog.connection(
                                'HID disconnected: ' + myHSs[i].name,
                            );
                            let data = {
                                name: myHSs[i].name,
                                id: myHSs[i].id,
                                serial: myHSs[i].serial,
                                slave1id: myHSs[i].slave1id.replace(
                                    'EPOS_',
                                    '',
                                ),
                                slave1serial: myHSs[i].slave1serial,
                                slave2id: myHSs[i].slave2id.replace(
                                    'EPOS_',
                                    '',
                                ),
                                slave2serial: myHSs[i].slave2serial,
                            };
                            postEvent('HeadsetRemoved', data);
                            if (i == 0) {
                                if (deviceIsSupported)
                                    postEvent(
                                        'HeadsetDisconnected',
                                        myHSs[0].name,
                                    );
                            }
                            myHSs[i].device.close();
                            myHSs.splice(i, 1);
                            if (i === 0) {
                                if (deviceIsSupported) await initHeadset();
                            }
                            return;
                        }
                    }
                }
            }
        });
    }
    //abl callback function
    async function ablloaded(msg, param) {
        if (msg === 'loaded') {
            mylog.init('abl.js was allocated in webhid.js');
        } else if (msg === 'devices') {
            if (mylog) mylog.message(param + ' ABL devices present');
            postEvent('BLsPresent', param);
            updateHeadset();
        } else console.log(msg + ' : ' + param);
    }
    //Initialization
    mylog = new log(MYCOLOR1, MYCOLOR2);
    myabl = new abl(ablloaded);
}

export default dseasdk;

/*EOF*/
